import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CustomerNotes } from "@app/models/customer-notes";
import { CustomerNoteService } from "@app/services/customer-note.service";

@Component({
    selector: "app-customer-note-node",
    templateUrl: "./customer-note-node.component.html",
    styleUrls: ["./customer-note-node.component.css"],
    standalone: false
})
export class CustomerNoteNodeComponent implements OnInit {
  @Input() level: number;
  @Input() customerNotes: Array<CustomerNotes>;
  @Input() selectedCustomerNotes: Array<CustomerNotes>;
  @Output() onAddCustomerNote = new EventEmitter<CustomerNotes>();
  @Output() onDeleteCustomerNote = new EventEmitter<CustomerNotes>();

  constructor(private customerNoteService: CustomerNoteService) {}

  ngOnInit(): void {}

  changeNoteStatus(item, value) {
    if (value.target.checked) {
      this.addCustomerNote(item);
    } else {
      this.deleteCustomerNote(item);
    }
  }

  addCustomerNote(item) {
    this.onAddCustomerNote.emit(item);
  }

  deleteCustomerNote(item) {
    this.onDeleteCustomerNote.emit(item);
  }

  isSelectedCustomerNote(item: CustomerNotes): boolean {
    if (!this.selectedCustomerNotes || !item) {
      return false;
    }
    return this.selectedCustomerNotes.some((selected) => selected && selected.id === item.id);
  }

  isIndeterminate(item: CustomerNotes): boolean {
    if (!item || !item.subCustomerNotes || item.subCustomerNotes.length === 0) {
      return false;
    }
    return !this.isSelectedCustomerNote(item) && this.hasSelectedDescendant(item);
  }

  isExpanded(item: CustomerNotes): boolean {
    return this.isSelectedCustomerNote(item) || this.hasSelectedDescendant(item);
  }

  private hasSelectedDescendant(item: CustomerNotes): boolean {
    if (!item || !item.subCustomerNotes || item.subCustomerNotes.length === 0) {
      return false;
    }
    return item.subCustomerNotes.some(
      (child) => this.isSelectedCustomerNote(child) || this.hasSelectedDescendant(child)
    );
  }
}
